import SpamFilters from './SpamFilters';

export default SpamFilters;
